interface PropsI {
  login: string;
  dashboard: string;
  settings: string;


 
}

export const paths: Readonly<PropsI> = {
  login: "/",
  settings: "/settings",
  dashboard: "/dashboard",
  // login: "/login",

  // dashboard: "/",

 
};

